/** Schüler alphabetisch, Eltern direkt darunter. Zugeordnete Eltern nicht noch einmal extra. */

export function nestUnterrichtContacts(contacts) {
  const list = contacts || [];
  const students = list.filter((contact) => contact.person_type === 'student');
  const studentIds = new Set(students.map((student) => String(student.person_id)));
  const byName = (a, b) => String(a.name || '').localeCompare(String(b.name || ''), 'de');
  const rows = students.slice().sort(byName).map((student) => ({
    student,
    guardians: list
      .filter((contact) => (
        contact.person_type === 'guardian'
        && String(contact.related_student_id || '') === String(student.person_id)
      ))
      .sort(byName),
  }));
  const orphans = list.filter((contact) => (
    contact.person_type === 'guardian'
    && !studentIds.has(String(contact.related_student_id || ''))
  ));
  return { rows, orphans };
}
